const DAY_MS = 86400000;
const ACTIVE_STATUSES = ['live', 'drafting'];

const byNumberDesc = (a, b) => (b.number || 0) - (a.number || 0);

// A season "airs" from its premiere until a week after its final episode
const airingWindow = (season) => {
  if (!season.start_date) return null;
  const start = new Date(`${String(season.start_date).slice(0, 10)}T00:00:00`);
  if (isNaN(start.getTime())) return null;
  const episodes = season.episode_count || 13;
  const interval = season.episode_interval_days || 7;
  const end = new Date(start.getTime() + ((episodes - 1) * interval + 7) * DAY_MS);
  return { start: start.getTime(), end: end.getTime() };
};

export const pickDefaultSeason = (seasons) => {
  const candidates = (seasons || []).filter((s) => !s.is_archived);
  if (!candidates.length) return null;

  const now = Date.now();
  const airing = candidates.filter((s) => {
    const w = airingWindow(s);
    return w && now >= w.start && now <= w.end;
  });
  if (airing.length) return airing.sort(byNumberDesc)[0];

  const active = candidates.filter((s) => ACTIVE_STATUSES.includes(s.status));
  if (active.length) return active.sort(byNumberDesc)[0];

  return [...candidates].sort(byNumberDesc)[0];
};

const storageKey = (userId) => `currentSeasonId:${userId}`;

export const rememberSeason = (userId, seasonId) => {
  if (!userId) return;
  if (seasonId) localStorage.setItem(storageKey(userId), seasonId);
  else localStorage.removeItem(storageKey(userId));
};

export const resolveSeason = (seasons, userId) => {
  const remembered = userId ? localStorage.getItem(storageKey(userId)) : null;
  const match = remembered && (seasons || []).find((s) => s.id === remembered && !s.is_archived);
  return match || pickDefaultSeason(seasons);
};
